const invoices = {
  // list: InvoiceList,
}

export default invoices
